
export default function AboutSection() {
  return (
    <section id="sobre" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl font-bold text-blue-900 mb-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
              Sobre a PrecNacional
            </h2>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed" style={{ fontFamily: 'Open Sans, sans-serif' }}>
              Somos uma empresa especializada em conectar credores de precatórios com investidores qualificados, 
              oferecendo soluções seguras e transparentes no mercado de direitos creditórios.
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed" style={{ fontFamily: 'Open Sans, sans-serif' }}>
              Nossa missão é proporcionar liquidez imediata aos portadores de precatórios, garantindo 
              as melhores condições de mercado através de um processo transparente e seguro.
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed" style={{ fontFamily: 'Open Sans, sans-serif' }}>
              Estamos iniciando nossa jornada no mercado de precatórios com foco em inovação, 
              transparência e excelência no atendimento aos nossos clientes.
            </p>
          </div>
          
          <div className="relative">
            <img 
              src="https://readdy.ai/api/search-image?query=Professional%20business%20handshake%20between%20two%20executives%20in%20elegant%20corporate%20office%20setting%2C%20confident%20business%20partnership%20moment%2C%20formal%20business%20attire%2C%20modern%20office%20environment%20with%20natural%20lighting%2C%20trust%20and%20reliability%20concept%2C%20professional%20photography%20style%2C%20clean%20background%2C%20successful%20business%20relationship%2C%20corporate%20credibility%20and%20confidence%20atmosphere&width=600&height=400&seq=about-trust-handshake&orientation=landscape"
              alt="Escritório PrecNacional"
              className="rounded-lg shadow-xl w-full h-96 object-cover object-top"
            />
            <div className="absolute inset-0 bg-blue-900 bg-opacity-10 rounded-lg"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
